import { Search } from "lucide-react";
import { Input } from "@trillion/ui/components/ui/input";
import { cn } from "@trillion/ui/lib/utils";

/** A grid's empty-state text when rows were fetched but the filter hid every one (sc-114202). */
export const NO_MATCHES_TEXT = "No matches";

/**
 * The grids' type-to-filter box (sc-114202): help-admin's toolbar search look — a Search icon inside an
 * `Input` — as a controlled field. The pattern's `*` wildcard rule lives in `@/lib/wildcard-match`.
 */
export function GridFilterInput({
  value,
  onChange,
  label,
  placeholder,
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  /** The input's accessible name. */
  label: string;
  placeholder: string;
  /** Merged onto the wrapper; the page header passes a fixed width. */
  className?: string;
}) {
  return (
    <div className={cn("relative w-full max-w-sm", className)}>
      <Search className="absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        aria-label={label}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-9"
      />
    </div>
  );
}
